import { Star, PartyPopper, Ban, Clock, CalendarRange, Sparkles, Theater } from "lucide-react";

export const TYPES = {
  class: { bg: "#1F2937", label: "Class", icon: Clock },
  practice: { bg: "#0EA5E9", label: "Lead Practice", icon: Sparkles },
  rehearsal: { bg: "#DB2777", label: "Dress Rehearsal", icon: CalendarRange },
  performance: { bg: "#0D9488", label: "Performance", icon: Theater },
  recital: { bg: "#2FB7B5", label: "Recital", icon: Star },
  event: { bg: "#8B5CF6", label: "Event", icon: PartyPopper },
  holiday: { bg: "#FB923C", label: "Holiday / Closure", icon: Ban },
};
export const STUDIO_WIDE = ["event", "holiday", "recital", "performance"];
export const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const parse = (s) => new Date(`${s}T00:00:00`);
export const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
export const startOfWeek = (d) => addDays(new Date(d.getFullYear(), d.getMonth(), d.getDate()), -d.getDay());
export const toMin = (t) => { if (!t) return null; const [h, m] = t.split(":").map(Number); return h * 60 + (m || 0); };
export const to12 = (t) => { if (!t) return ""; const [h, m] = t.split(":").map(Number); return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h >= 12 ? "PM" : "AM"}`; };
export const short12 = (t) => { if (!t) return ""; const [h, m] = t.split(":").map(Number); return `${((h + 11) % 12) + 1}${m ? `:${String(m).padStart(2, "0")}` : ""}${h >= 12 ? "p" : "a"}`; };
export const duration = (s, e) => {
  const a = toMin(s), b = toMin(e);
  if (a == null || b == null || b <= a) return "";
  const h = Math.floor((b - a) / 60), m = (b - a) % 60;
  return [h ? `${h}h` : "", m ? `${m}m` : ""].filter(Boolean).join(" ");
};
export const timeRange = (it) => it.all_day ? "All day" : `${to12(it.start_time)}${it.end_time ? ` – ${to12(it.end_time)}` : ""}`;
export const prettyDay = (s, opts = { weekday: "long", month: "long", day: "numeric", year: "numeric" }) => parse(s).toLocaleDateString(undefined, opts);

export function rangeFor(view, cursor) {
  if (view === "month") {
    const s = startOfWeek(new Date(cursor.getFullYear(), cursor.getMonth(), 1));
    return [s, addDays(s, 41)];
  }
  if (view === "week") { const s = startOfWeek(cursor); return [s, addDays(s, 6)]; }
  if (view === "day") return [cursor, cursor];
  return [cursor, addDays(cursor, 30)];
}

export function shift(view, cursor, dir) {
  if (view === "month") return new Date(cursor.getFullYear(), cursor.getMonth() + dir, 1);
  return addDays(cursor, dir * (view === "week" ? 7 : view === "day" ? 1 : 31));
}

export function rangeLabel(view, cursor) {
  const [s, e] = rangeFor(view, cursor);
  if (view === "month") return cursor.toLocaleDateString(undefined, { month: "long", year: "numeric" });
  if (view === "day") return cursor.toLocaleDateString(undefined, { weekday: "long", month: "short", day: "numeric", year: "numeric" });
  const f = (d, y) => d.toLocaleDateString(undefined, { month: "short", day: "numeric", ...(y ? { year: "numeric" } : {}) });
  return `${f(s)} – ${f(e, true)}`;
}

export function layoutDay(items) {
  const timed = items.filter((i) => !i.all_day && toMin(i.start_time) != null)
    .map((i) => ({ item: i, s: toMin(i.start_time), e: Math.max(toMin(i.end_time) ?? toMin(i.start_time) + 60, toMin(i.start_time) + 20) }))
    .sort((a, b) => a.s - b.s || b.e - a.e);
  const out = [];
  let cluster = [], end = -1;
  const flush = () => { const lanes = Math.max(...cluster.map((c) => c.lane + 1)); cluster.forEach((c) => out.push({ ...c, lanes })); cluster = []; };
  timed.forEach((t) => {
    if (cluster.length && t.s >= end) flush();
    const used = new Set(cluster.filter((c) => c.e > t.s).map((c) => c.lane));
    let lane = 0; while (used.has(lane)) lane += 1;
    cluster.push({ ...t, lane }); end = Math.max(end, t.e);
  });
  if (cluster.length) flush();
  return out;
}
